module.exports = __webpack_public_path__ + "img/ico-close-grey.3b954cfd.svg";